export default {
  query: '/auth/res/query', // 获取(全部)某个系统的资源列表信息
  urlQuery: '/auth/res/devurl/query', // 开发配置url查询
  create: '/auth/res/create', // 新增资源
  update: '/auth/res/update', // 编辑资源
  validRes: '/auth/res/valid/update', // 停用、启用某个资源
  orderUpdate: '/auth/res/order/update', // 资源排序码修改
  devUpdate: '/auth/res/dev/update', // 开发配置接口
  delete: '/auth/res/delete', // 删除资源
  queryAbility: '/auth/res/ability/query', // 获取功能
  updateAbility: '/auth/res/ability/update', // 更改功能
};



// WEBPACK FOOTER //
// ./src/api/resource.js